export const benefits = {
  ai: 'مدرس ذكي',
  ai_desc: 'تعلم مع مدرس شخصي يتكيف مع احتياجاتك ومستواك',
  practice: 'تدريب تفاعلي',
  practice_desc: 'تمارين وتدريبات عملية مصممة خصيصاً لتحسين مهاراتك',
  progress: 'تتبع التقدم',
  progress_desc: 'راقب تقدمك وحسن أداءك مع تقارير تفصيلية'
};